import styled from 'styled-components'

export const FlexContainer = styled.div`
  display: flex;
  min-height: 100vh;
  flex-grow: 1;
`
